module.exports = __webpack_public_path__ + "workspace/static/img/tenantMgmtMasterMsspEight.056851a.png";